import { GridWidgetService } from "../grid-widget.services";
import { SystemService } from "common/services/core-services/system.service";
import { MetaModel } from "common/models/utility-models/base-model";
import { Injectable } from "@angular/core";
import { FeedbackMappingModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-data-model";
import { FeedbackMappingListingModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-grid-model";
import { FeedbackMappingGridMetaModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-grid-meta-model";
import { FeedbackMappingGridDataService } from "common/services/data-services/admin/feedback-mapping/feedback-mapping-grid-data.service";
import { API_URL } from "common/constants/sm-constants";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { EditFeedbackTitleDataService } from "common/services/data-services/admin/feedback-mapping/editFeedbackTitle-data.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class FeedbackMappingGridWidgetService extends GridWidgetService<
  FeedbackMappingModel,
  FeedbackMappingListingModel
> {
  EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  EXCEL_EXTENSION = ".xlsx";
  constructor(
    protected override ds: FeedbackMappingGridDataService,
    protected systemService: SystemService,
    private editFeedbacktitle: EditFeedbackTitleDataService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new FeedbackMappingGridMetaModel().getMetaModel();
    return meta;
  }

  getExcelData(body) {
    this.ds
      .postDataToCustomEndPoint(
        body,
        null,
        environment.apiUrl + API_URL.feedbackFormResponsesForExcelDownload
      )
      .then((data) => {
        // this.systemService.showSuccess(data['header'].msg);
        //console.log(data)
        if (data["status"] === "Success") {
          this.exportToExcel(data["details"], "feedbackData");
        } else {
          this.systemService.showError(data['error']);
        }
        return data;
      })
      .catch((err) => {
        this.systemService.showError(err);
      });
  }

  public exportToExcel(jsonData: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, fileName + this.EXCEL_EXTENSION);
  }

  async editFeedbackTitle(payload: any): Promise<any> {
    // try {
    //   const data = await this.editFeedbacktitle.postData(payload);
    //   this.systemService.showSuccess(data.header.msg);
    // } catch (err) {
    //   this.systemService.showError(err);
    // }
    return await new Promise((resolve, reject) => {
      this.editFeedbacktitle
        .postData(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
